import { SafePromise } from '@benzinga/safe-await';

import { RestfulClient } from '@benzinga/session';
import { CommentCountResponse } from '../entities';
import { Session } from '@benzinga/session';
import { ArticleEnvironment } from '../environment';

export class CommentsRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(ArticleEnvironment).commentsUrl, session, { 'x-device-key': true });
  }

  getCommentCount = (id: number): SafePromise<CommentCountResponse> => {
    const url = this.URL('api/comment-count', {
      id,
    });
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };
}
